export const MAX_ALLOWED_IMAGES = 16;
export const FEATURED_IMAGE_FIELD = 'featured_image';
export const LOCATION_IMAGES_FIELD = 'location_images';

export const NO_EMAILS_HELP_MESSAGE =
  "If you don't provide a contact email, we default to the location's email and then to the business owner's email.";
